import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import { createBrowserHistory } from 'history';
import { Router } from "react-router";
export const history = createBrowserHistory();

document.title = "Platform Area";
ReactDOM.render( <Router history={history}><App /></Router>, document.getElementById('root'));
